import ProductApiV2 from 'api/v2/admins/products-api-v2'
import { SelectSearchField } from 'components'
import { useState } from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

/**
* Search field to select product by product code.
* @param {string} name - Formik field name
* @param {string} label - Field Label
* @param {bool} required - It will show required badge if it set `true`
*/
const ProductSelectSearchField = ({
  name,
  label,
  required,
  ...props
}) => {

  const [ searchProducts, setSearchProducts ] = useState([])
  const [ isSearchLoading, setSearchLoading ] = useState(false)

  var productSearchTimeout = null

  // search products by similar sku or name
  const getProducts = (keyword) => {
    setSearchLoading(true)
    const additionalFilters = {
      query: keyword
    }

    ProductApiV2.get({ additionalFilters: additionalFilters })
      .then((response) => {
        setSearchProducts(response.data.products)
        setSearchLoading(false)
      })
      .catch((error) => {
        alert(error.message)
      })
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.sku }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option.name }</span>
      <span className='mr-3'>{ `${option.quantity === 0 ? '(Out of Stock)' : ''}` } </span>
    </>
  )

  // handler to search products
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    if (productSearchTimeout) clearTimeout(productSearchTimeout)
    productSearchTimeout = setTimeout(() => {
      getProducts(searchText)
    }, 700)
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search with product SKU or Name'
      dataList={ searchProducts }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      { ...props }
    />
  )
}

ProductSelectSearchField.propTypes    = propTypes
ProductSelectSearchField.defaultProps = defaultProps

export default ProductSelectSearchField
